import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ValidationService } from '../services/validation.service';

@Component({
	selector: 'sm-control-messages',
	template: `<div class="form-control-feedback" *ngIf="errorMessage != null">{{errorMessage}}</div>`
})
export class ControlMessagesComponent implements OnInit, OnDestroy {
	@Input() control: FormControl;
	@Input() checkDirty: boolean = true;
	@Input() customErrorMessage: string;

	errorMessage: string = null;
	private _sub: any;

	constructor(private _validationService: ValidationService) {
		this.errorMessage = null;
	}

	ngOnInit() {
		this._sub = this.control.statusChanges.subscribe(x => this.updateMessages());
	}

	ngOnDestroy() {
		this._sub.unsubscribe();
	}

	updateMessages(): void {
		this.errorMessage = null;

		if ((!this.checkDirty || this.control.dirty) && this.control.enabled) {
			for (let propertyName in this.control.errors) {
				if (this.control.errors.hasOwnProperty(propertyName)) {
					if (this.customErrorMessage) {
						this.errorMessage = this.customErrorMessage;
					} else {
						this.errorMessage = this._validationService.getErrorMessageFor(propertyName, this.control.errors[propertyName]);
					}
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-control-messages.component.ts